import React from 'react';

const CheckCookieProvider: React.FC = ({children}) => {
  if (!navigator.cookieEnabled) {
    return (
      <div>
        <h1>Включитите куки!</h1>
      </div>
    );
  }

  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  )
};

export default CheckCookieProvider;
